<div [formGroup]="form" class="mb-6">
    <label [for]="label" class="block text-surface-900 dark:text-surface-0 text-xl font-medium">{{label}}</label>
     <p-inputnumber [min]="min" [max]="max" [id]="label" [placeholder]="placeholder" class="w-full md:w-[30rem] mb-2" [formControlName]="field"/>
    @if (form.controls[field].invalid && (form.controls[field].dirty || form.controls[field].touched)) {
        <div class="alert alert-danger">
        @if (form.controls[field].hasError('required')) {
            <p-message severity="error" variant="simple" size="small">
               {{label}} is required. 
            </p-message>
            
        }
        @if (form.controls[field].hasError('max')) {
            <p-message severity="error" variant="simple" size="small">
               {{label}} must be less than or equal to {{form.get(`${field}`)?.errors?.['max'].max}} 
            </p-message>
            
        }
        </div>
    }
</div>    